export default "__VITE_ASSET__a24821c0__"